// import react
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

//import components
import CommonToast from "../../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import Loader from "../../../../../components/Loader/Index";
import ApprovalTopNavComponent from "../../../../../components/_utils/CommonTopNav/ApprovalTopNav";
import CardContainer from "../../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import formatDateViewAll from "../../../../../utils/formatDateViewAll";
import SecondaryButton from "../../../../../components/_utils/CommonButtons/SecondaryButton";
import TextWithBank from "../../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TaxTransactionDetailsPopup from "../../../../../components/Transactions/TaxTransaction/TaxTransactionDetailsPopup";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import TEXT from "../../../../../utils/globalText";

//imports redux
import {
  approveTdsTransaction,
  rejectTdsTransaction,
} from "../../../../../redux/features/transactions/taxTransaction/taxTransactionApproval";
import {
  getCreateTransactionBalance,
  resetOwnerBalance,
} from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../../utils/configurationProvider";
import ICONS from "../../../../../assets/Icons";

const TaxationMultiApproval = () => {
  const refreshingToastId = useRef(null);
  const isSubmittingRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [isMobileResponsive, setIsMobileResponsive] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [AllBeneTxnAccounts, setAllBeneTxnAccounts] = useState([]);
  const [refreshId, setRefreshId] = useState("");
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [PrevBalance, setPrevBalance] = useState(null);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [deniedId, SetdeniedId] = useState();

  const services = useSelector((state) => state.refreshToken.services);
  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  const checkService =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const handleInputChange = (event) => {
    let value = event.target.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    value = value.replace(/^\s+/, "");

    value = value.replace(/\s{2,}/g, " ");

    value = value.slice(
      GlobalConfiguration.lengthCheckZero,
      GlobalConfiguration.inputMaxLength,
    );

    setDeclineReason(value);
  };

  const handleRefresh = (e, id, txnIdParam, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      setPrevBalance(prevBalance);
      setrefreshAnimation(id);
      setRefreshId(txnIdParam);
      setFailedRefreshId((prev) =>
        prev.filter((failedId) => failedId !== txnIdParam),
      );

      dispatch(getCreateTransactionBalance(id));
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VAccountBalance,Admin",
        },
      });
    }
  };

  let total = transactionFilterData?.reduce((acc, obj) => {
    return acc + parseInt(obj?.amount);
  }, GlobalConfiguration.lengthCheckZero);

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllBeneTxnAccounts(updatedAccounts);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const finalize = () => {
    setShowLoader(false);
    setDeclineReason("");
  };

  const handleTxnMultiRejecting = () => {
    setTimeout(() => {
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleTxnApproval = async (id) => {
    setLoading(true);
    if (isMobileResponsive) {
    } else {
      showLoadingToast("Approving transactions");
    }

    if (transactionFilterID.length > GlobalConfiguration.lengthCheckZero) {
      const data = await dispatch(approveTdsTransaction(id));

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        if (data?.payload?.status === errorcode.errorFailed) {
          setTimeout(() => {
            CommonToast({
              text: data?.payload?.error,
              icon: ICONS?.ERROR_WHITE_CIRCLE,

              variant: "var(--error)",
              buttonNeeded: false,
              btnProps: {
                enabledBgColor: "var(--primary-bg)",
                enabledTextColor: "var(--text-primary)",
                btnText: "",
                handleFunction: () => {},
                icon: "",
                btnType: "button",
                isDisabled: false,
                hoverOption: "white",
              },
            });
          }, IntervalConfiguration.intervalMedium);
        }
        if (
          data?.payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          setTimeout(() => {
            navigate("/feature_not_assigned", {
              state: {
                unavailableService: "ATDSTransaction",
              },
            });
          }, IntervalConfiguration.intervalMedium);
        } else if (data?.payload?.status === true) {
          const selectedscheduleData = {
            selectedSendTransactions: data?.payload?.transactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem(
            "selectedTaxData",
            JSON.stringify(selectedscheduleData),
          );
          navigate(
            "/tax_transaction_dashboard/tax_transaction_multi_select/tax_transaction_multi_approval/tax_transaction_success",
          );
        } else if (
          data?.payload?.response?.data?.status === false ||
          data?.payload
        ) {
          navigate(
            "/tax_transaction_dashboard/tax_transaction_multi_select/tax_transaction_multi_approval/tax_transaction_failed",
          );
        }
      }, IntervalConfiguration.intervalExtraLarge);
    }
  };

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedTaxData"),
    );
    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions,
      );
      setTransactionFilterID(storedSelectedApproval.selectedTransactions);
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileResponsive(
        window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
      );
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      refreshingToastId.current = null;
      setTimeout(() => {
        refreshingToastId.current = UniversalRefreshToast();
      }, IntervalConfiguration.intervalTiny);
    } else if (createTransactionBankRefreshData?.status) {
      if (refreshingToastId.current) {
        toast.dismiss(refreshingToastId.current);
        refreshingToastId.current = null;
      } else {
        toast.dismiss();
      }
      setTimeout(() => {
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",

          variant: "var(--success)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      if (refreshId) {
        setFailedRefreshId((prev) =>
          prev.filter((failedId) => failedId !== refreshId),
        );
      }
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      if (refreshingToastId.current) {
        toast.dismiss(refreshingToastId.current);
        refreshingToastId.current = null;
      } else {
        toast.dismiss();
      }
      setTimeout(() => {
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      if (refreshId) {
        setFailedRefreshId((prev) => [...prev, refreshId]);
      }
    }
    if (createTransactionBankRefreshData) {
      let data = transactionFilterData.map((val) => {
        if (
          val.owner_account_id ===
          createTransactionBankRefreshData?.owner_accounts[
            GlobalConfiguration.lengthCheckZero
          ]?.owner_account_id
        ) {
          return {
            ...val,
            owner_account_balance:
              createTransactionBankRefreshData?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance,
            owner_account_balance_last_fetched_at_in_words:
              createTransactionBankRefreshData?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance_last_fetched_at_in_words,
          };
        }
        return val;
      });

      setTransactionFilterData(data);
      const selectedscheduleData = {
        selectedSendTransactions: data,
        selectedTransactions: transactionFilterID,
      };

      sessionStorage.setItem(
        "selectedTaxData",
        JSON.stringify(selectedscheduleData),
      );
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    refreshAnimation,
    refreshId,
    dispatch,
    transactionFilterID,
    transactionFilterData,
  ]);

  const handleReject = async (id, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    try {
      if (
        services?.find(
          (service) => service === "ATDSTransaction" || service === "Admin",
        ) !== undefined
      ) {
        // Token Check
        if (!sessionStorage.getItem("q2p_token")) {
          return;
        }

        setShowLoader(true);

        showLoadingToast("Rejecting transaction");
        handleTxnMultiRejecting();

        const result = await dispatch(
          rejectTdsTransaction({
            id: id,
            accountIdData: reason,
            services,
            navigate,
          }),
        );

        const payload = result?.payload;

        // wait for loader animation
        await new Promise((resolve) =>
          setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
        );

        if (payload?.status === errorcode.errorFailed) {
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
            btnProps: {
              enabledBgColor: "var(--primary-bg)",
              enabledTextColor: "var(--text-primary)",
              btnText: "",
              handleFunction: () => {},
              icon: "",
              btnType: "button",
              isDisabled: false,
              hoverOption: "white",
            },
          });
          return finalize();
        }

        if (
          payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "ATDSTransaction, Admin" },
          });
          return finalize();
        }

        // MULTI approval flow

        if (result?.error) {
          navigate(
            "/tax_transaction_dashboard/tax_transaction_multi_select/tax_transaction_multi_approval/tax_transaction_failed",
          );
        } else {
          navigate(
            "/tax_transaction_dashboard/tax_transaction_multi_select/tax_transaction_multi_approval/tax_transaction_declined",
          );
        }

        // SINGLE approval flow
        const updatedData = AllBeneTxnAccounts?.map((item) => {
          if (item.txn_id !== id) return item;

          const tx =
            payload?.transactions?.[GlobalConfiguration.lengthCheckZero];
          let lifecycleStatus = "error";
          let errorMessage = "";

          // lifecycle status logic
          if (payload?.status === true) {
            lifecycleStatus =
              tx?.lifecycle_status === "rejected"
                ? "rejected"
                : tx?.lifecycle_status === "pending"
                  ? "pendingOne"
                  : "error";
          }

          // error message handling
          if (
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]?.errors
          ) {
            const errors =
              payload.errors.base[GlobalConfiguration.lengthCheckZero].errors;
            errorMessage = errors[GlobalConfiguration.lengthCheckZero];
          } else if (
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ) {
            errorMessage =
              payload.errors.base[GlobalConfiguration.lengthCheckZero];
          }

          return {
            ...item,
            lifecycle_status:
              item.lifecycle_status === "pending" && payload?.status === true
                ? lifecycleStatus
                : "error",
            rejected: true,
            rejection_reason: reason,
            error: payload?.status === false ? "true" : "false",
            message: payload?.status === false ? errorMessage : "",
          };
        });

        updateAllAccounts(updatedData);

        finalize();
      } else {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ATDSTransaction, Admin",
          },
        });
      }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  return (
    <>
      {showPopup && (
        <>
          <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <SmallPopupWithInput
              headerTitle={TEXT.REJECT_REASON_LABEL}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              secondHeaderTitle={TEXT.REJECTION_REASON_PROMPT_REIMBURSEMENT}
              secondHeaderFontWeight="normal"
              secondHeaderFontColor="text-secondary"
              secondHeaderTextSize="font-xs"
              inputPlaceholder={TEXT.REASON_10_150_CHAR}
              inputVariant={
                declineReason &&
                declineReason.length > GlobalConfiguration.accountnormalLength
                  ? "verified"
                  : declineReason &&
                      declineReason.length < GlobalConfiguration.panLength
                    ? "typing"
                    : "default"
              }
              inputBgColor="var(--primary-bg)"
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                if (!showLoader) {
                  handleInputChange(e);
                }
              }}
              inputValue={declineReason}
              inputFontKind="small"
              inputIsFullWidth={true}
              btnOneText={TEXT.CANCEL}
              btnOneHandleFunction={() => {
                if (!showLoader) {
                  setShowPopup(false);
                }
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnOneIsDisabled={showLoader}
              btnTwoText={TEXT.REJECT}
              btnTwoHandleFunction={() => {
                if (
                  !declineReason ||
                  declineReason.length < GlobalConfiguration.panLength ||
                  showLoader
                ) {
                  return;
                }
                handleReject(deniedId, declineReason);
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={
                !declineReason ||
                declineReason.length < GlobalConfiguration.panLength
              }
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={showLoader ? true : false}
              btnTwoIsLoading={showLoader ? true : false}
              btnTwoHoverOption="black"
              btnTwoInActiveVariantNeeded={true}
            />
          </div>
        </>
      )}
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <TaxTransactionDetailsPopup
            closePopup={() => {
              setShowTxnDetailPop(false);
            }}
            transactionHeader={"Tax transaction details"}
            tax_txn_id={txnId}
            typePopup={true}
            typeSingle={true}
          />
        </div>
      )}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {loading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : null}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="int-txn-mutli-container">
          <ApprovalTopNavComponent
            handleBack={() => navigate(-1)}
            topNavCtaBtn1Needed={false}
            topNavHeader={total}
            topNavSubText={"Total amount"}
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject",
              handleFunction: () => handleOpenPopup(transactionFilterID),
              enabledBgColor: "var(--failed)",
              enabledTextColor: "var(--text-primary)",
              icon: "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg",
              iconToBeAlign: "right",
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve",
              handleFunction: () => handleTxnApproval(transactionFilterID),
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: "https://q2pay.in/new_assets/common/approval/approve_circle_green_checkmark.svg",

              iconToBeAlign: "right",
            }}
            BottomHeader={`Post approval process`}
            BottomSubText={`Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: loading,
                handleFunction: () => {},
                isDisabled: false,
                icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
                title: "Refresh reimbursement",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div className="int-txn-mutli-select-data-card">
          <div className="standard-card-alignment gap-gap-md ">
            {transactionFilterData?.map((val, i) => {
              return (
                <div key={val?.txn_id || i}>
                  <CardContainer
                    isDisabled={false}
                    isSelected={false}
                    onClickHandler={(e) => {
                      e.stopPropagation();
                    }}
                    isNoHoverRequired={true}
                  >
                    <card-body>
                      <TextWithIcon
                        type={"Amount"}
                        fontWeight={"semibold"}
                        text={val?.amount}
                        textColor={"var(--settled)"}
                        subText={"Amount"}
                        iconComponentArray={
                          val.tds_account_approval_status !== "pending"
                            ? [
                                ...(val?.confidential_transaction === "Y"
                                  ? [
                                      {
                                        icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                                        title: "confidential",
                                        isDisabled: false,
                                      },
                                    ]
                                  : []),
                              ]
                            : []
                        }
                      />
                      <TextWithIcon
                        type={"Text"}
                        fontWeight={
                          val.tds_account_approval_status === "pending"
                            ? "var(--font-normal)"
                            : "var(--font-semibold)"
                        }
                        text={val.tds_account_name
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word
                                .charAt(GlobalConfiguration.lengthCheckZero)
                                .toUpperCase() +
                              word.slice(GlobalConfiguration.lengthCheckOne),
                          )
                          .join(" ")}
                        textColor={"var(--text-primary)"}
                        subText="Account name"
                      />
                      <div className="relative">
                        <div className="flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border mx-margin-sm border-primary-bg">
                          <p
                            className={`text-font-sm text-text-primary w-full truncate  font-normal `}
                          >
                            {val.created_on
                              ? formatDateViewAll(val.created_on, false, false)
                              : "Not given"}
                          </p>
                          <div className="w-full   flex  justify-between items-center ">
                            <p
                              className={`text-font-xs w-width-md text-text-secondary transform-none  font-normal`}
                            >
                              Date
                            </p>
                            <div className="z-z-index-overlay absolute right-0 bottom-0.5">
                              <SecondaryButton
                                btnText={"Additional details "}
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  openBeneTxnDetailModal();
                                  setTxnId(val.txn_id);
                                }}
                                isDisabled={false}
                                enabledBgColor={"var(--text-primary)"}
                                enabledTextColor={"var(--primary-bg)"}
                                icon={
                                  "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <TextWithBank
                        text={val.owner_account_bank_acc_no}
                        type={"AccountNumber"}
                        subText={"Source account"}
                        fontWeight={"normal"}
                        textColor={"var(--text-primary)"}
                        ifscCode={val?.owner_account_ifsc_code}
                      />

                      <TextWithIcon
                        type="Amount"
                        fontWeight={"semibold"}
                        text={
                          val?.owner_account_balance
                            ? val?.owner_account_balance
                            : "Not available"
                        }
                        subText={"Balance"}
                        textColor={
                          Number(val?.owner_account_balance) >=
                          Number(val?.amount)
                            ? "var(--settled)"
                            : "var(--failed)"
                        }
                        iconComponentArray={[
                          ...(function () {
                            let iconUrl = "";
                            let titleText = "";

                            if (
                              createTransactionBankRefreshLoading &&
                              refreshId === val?.txn_id
                            ) {
                              iconUrl =
                                "https://q2pay.in/new_assets/gifs/inputloader_white.gif";
                              titleText = "Balance updating";
                            } else if (failedRefreshId.includes(val?.txn_id)) {
                              iconUrl =
                                "https://q2pay.in/new_assets/common/view_all/error_with_orange_circle.svg";
                              titleText = "Balance fetch failed";
                            } else if (
                              !createTransactionBankRefreshLoading &&
                              refreshId === val?.txn_id &&
                              val?.owner_account_id === refreshAnimation &&
                              PrevBalance !== undefined &&
                              Number(val?.owner_account_balance) !==
                                Number(PrevBalance)
                            ) {
                              if (
                                Number(val?.owner_account_balance) >
                                Number(PrevBalance)
                              ) {
                                iconUrl =
                                  "https://q2pay.in/new_assets/gifs/arrow_up_green_gif.gif";
                                titleText = "Balance updated";
                              } else if (
                                Number(val?.owner_account_balance) <
                                Number(PrevBalance)
                              ) {
                                iconUrl =
                                  "https://q2pay.in/new_assets/gifs/arrow_down_red_gif.gif";
                                titleText = "Balance updated";
                              }
                            }

                            return iconUrl
                              ? [
                                  {
                                    icon: iconUrl,
                                    title: titleText,
                                    isDisabled: false,
                                  },
                                ]
                              : [];
                          })(),
                          ...(() => {
                            if (checkService)
                              return [
                                {
                                  icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
                                  title: "Refresh balance",
                                  isDisabled: !(
                                    services?.includes("VAccountBalance") ||
                                    services?.includes("Admin")
                                  ),
                                  onClick: (e) => {
                                    if (
                                      !createTransactionBankRefreshLoading ||
                                      refreshId !== val?.txn_id
                                    ) {
                                      if (
                                        services?.includes("VAccountBalance") ||
                                        services?.includes("Admin")
                                      ) {
                                        handleRefresh(
                                          e,
                                          val?.owner_account_id,
                                          val?.txn_id,
                                          val?.owner_account_balance,
                                        );
                                      } else {
                                        e.stopPropagation();
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "VAccountBalance,Admin",
                                          },
                                        });
                                      }
                                    } else {
                                      e.stopPropagation();
                                    }
                                  },
                                  bgColor: "var(--primary-nav)",
                                },
                              ];
                            return [];
                          })(),
                        ]}
                      />
                      <TextWithIcon
                        text={val?.labels?.join(", ") || "No labels assigned"}
                        fontWeight={"normal"}
                        textColor={"var(--text-primary)"}
                        iconComponentArray={[
                          {
                            icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                          },
                        ]}
                      />
                    </card-body>
                  </CardContainer>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxationMultiApproval;
